import NewProjectPage from "@/components/screens/project/new";

export default function NewProject() {
  return <NewProjectPage />;
}
